import { type ReactElement, useEffect, useState } from 'react'

// 描画を1tick遅らせるためのラッパー
// eslint-disable-next-line sonarjs/prefer-read-only-props
export function NextTickRender({ children, fallback }: { children: ReactElement; fallback?: ReactElement }) {
  const [flag, setFlag] = useState(false)
  useEffect(() => {
    // eslint-disable-next-line react-hooks/set-state-in-effect
    setFlag(true)
  }, [])

  if (!flag) {
    return fallback ?? <></>
  }

  return <>{children}</>
}
